export default __webpack_public_path__ + "static/media/TF_11.34bcee2c.png";